<template>
	<div>
		<navpage
			ref="navPage"
			:middle="true"
			pagename="explore"
			:displayDates="true"
			:displayFilters="true"
			:displayListPanels="false"
			:updateParameters="false"
			:displayAllButton="false"
			@datepickercreated="setDates()"
			@changedate="changeDate($event)"
		></navpage>
		<div id="content-page">
			<explorefilters
				ref="explorefilters"
				v-bind="{ selectedDate: filters.date }"
				@trendfilters="trendFilters($event)"
			></explorefilters>
			<listcategories
				ref="listCategories"
				request="tag"
				:filters="filters"
				:showlistcategory="showlistcategory"
				@removeBrands="removeBrands"
				@changeListCat="changeListCat($event)"
				@filters="trendFilters($event)"
			></listcategories>
			<div v-if="!noData">
				<numbers ref="numbers" v-bind="filters" @nodata="handleNoData"></numbers>
				<div class="row dynvibeRow" style="margin-top: 20px">
					<contentgrowth ref="contentgrowth" v-bind="filters" @clicked="keywordClicked"></contentgrowth>
				</div>
				<div class="row dynvibeRow">
					<div class="col-lg-12">
						<div class="dynvibeBox">
							<div class="col-lg-12">
								<div class="col-lg-12 dynvibeTitleBox">
									<h2>Profiles volume Comparison</h2>
								</div>
							</div>
							<div class="col-lg-12">
								<div style="float: left; padding-left: 20px; padding-bottom: 20px">
									<label class="labelCheckbox" style="margin-right: 35px">
										All
										<input type="checkbox" v-model="noStacked" />
										<span class="checkboxmark"></span>
									</label>
									<label class="labelCheckbox" v-if="noStacked">
										Evolution
										<input type="checkbox" v-model="displayGrowth" />
										<span class="checkboxmark"></span>
									</label>
								</div>
							</div>
							<div class="col-lg-12">
								<dynvibecolumnstacked
									ref="volumeComparison"
									axios="volumeComparison"
									title="Posts"
									:filters="filters"
									:noStacked="noStacked"
									:displayGrowth="displayGrowth"
									:explorePage="true"
									@clicked="keywordClicked"
								></dynvibecolumnstacked>
							</div>
						</div>
					</div>
				</div>
				<div class="row dynvibeRow">
					<div class="col-lg-12">
						<div class="dynvibeBox">
							<div class="col-lg-12 dynvibeTitleBox">
								<h2>Profiles Volume Evolution</h2>
							</div>
							<div class="col-lg-11" style="padding-top: 5px">
								<div v-if="!noStockDataVol">
									<label class="labelRadio"
										>Daily
										<input
											type="radio"
											name="groupingVolDate"
											value="day"
											v-model="graphrangeVol"
											:checked="graphrangeVol === 'day'"
										/>
										<span class="checkmark"></span>
									</label>
									<label class="labelRadio"
										>Weekly
										<input
											type="radio"
											name="groupingVolDate"
											value="week"
											v-model="graphrangeVol"
											:checked="graphrangeVol === 'week'"
										/>
										<span class="checkmark"></span>
									</label>
									<label class="labelRadio"
										>Monthly
										<input
											type="radio"
											name="groupingVolDate"
											value="month"
											v-model="graphrangeVol"
											:checked="graphrangeVol === 'month'"
										/>
										<span class="checkmark"></span>
									</label>
								</div>
								<dynvibestock
									:constructorType="'stockChart'"
									ref="stockVol"
									axios="categoriesVolume"
									:type="'stockChart'"
									:typo="'search'"
									:explorePage="true"
									:legend="true"
									:filters="filters"
									:selectedCountry="selectedCountryVol"
									:displaycumulative="false"
									:graphrange="graphrangeVol"
									@getcountries="editCountries($event)"
									@clicked="keywordClicked"
									@noStockData="noStockDataVol = $event"
									@zoomchart="changeZoomChart($event, 'volume')"
								></dynvibestock>
							</div>
							<div class="col-lg-1" style="padding-top: 5px">
								<label class="labelRadio" v-if="filters.country.length != 1">
									All
									<input
										type="radio"
										name="groupingVolCountry"
										value="All"
										v-model="selectedCountryVol"
										:checked="selectedCountryVol === 'All'"
									/>
									<span class="checkmark"></span>
								</label>
								<div v-if="!noStockDataVol">
									<div v-for="country in stockCountries" :key="country">
										<label class="labelRadio">
											{{ country }}
											<input
												type="radio"
												name="groupingVolCountry"
												:value="country.toLowerCase()"
												v-model="selectedCountryVol"
												:checked="selectedCountryVol === country"
											/>
											<span class="checkmark"></span>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row dynvibeRow">
					<div class="col-lg-12">
						<div class="dynvibeBox">
							<div class="col-lg-12 dynvibeTitleBox">
								<h2>Profiles Engagement Evolution</h2>
							</div>

							<div class="col-lg-11" style="padding-top: 5px">
								<div v-if="!noStockDataEng">
									<label class="labelRadio"
										>Daily
										<input
											type="radio"
											name="groupingEngDate"
											value="day"
											v-model="graphrangeEng"
											:checked="graphrangeEng === 'day'"
										/>
										<span class="checkmark"></span>
									</label>
									<label class="labelRadio"
										>Weekly
										<input
											type="radio"
											name="groupingEngDate"
											value="week"
											v-model="graphrangeEng"
											:checked="graphrangeEng === 'week'"
										/>
										<span class="checkmark"></span>
									</label>
									<label class="labelRadio"
										>Monthly
										<input
											type="radio"
											name="groupingEngDate"
											value="month"
											v-model="graphrangeEng"
											:checked="graphrangeEng === 'month'"
										/>
										<span class="checkmark"></span>
									</label>
								</div>
								<dynvibestock
									:constructorType="'stockChart'"
									ref="stockEng"
									axios="categoriesEngagement"
									:type="'stockChart'"
									:typo="'search'"
									:legend="true"
									:explorePage="true"
									:filters="filters"
									:selectedCountry="selectedCountryEng"
									:displaycumulative="false"
									:graphrange="graphrangeEng"
									@getcountries="editCountries($event)"
									@clicked="keywordClicked"
									@noStockData="noStockDataEng = $event"
									@zoomchart="changeZoomChart($event, 'engagement')"
								></dynvibestock>
							</div>
							<div class="col-lg-1" style="padding-top: 5px">
								<label class="labelRadio" v-if="filters.country.length != 1">
									All
									<input
										type="radio"
										name="groupingEngCountry"
										value="All"
										v-model="selectedCountryEng"
										:checked="selectedCountryEng === 'All'"
									/>
									<span class="checkmark"></span>
								</label>
								<div v-if="!noStockDataEng">
									<div v-for="country in stockCountries" :key="country">
										<label class="labelRadio">
											{{ country }}
											<input
												type="radio"
												name="groupingEngCountry"
												:value="country.toLowerCase()"
												v-model="selectedCountryEng"
												:checked="selectedCountryEng === country"
											/>
											<span class="checkmark"></span>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row dynvibeRow">
					<div class="col-lg-12">
						<div class="dynvibeBox">
							<div class="col-lg-12">
								<div class="col-lg-12 dynvibeTitleBox">
									<h2>Profiles Dynamic</h2>
								</div>
							</div>
							<div class="col-lg-12">
								<dynvibedynamiccategories
									ref="categoriesdynamic"
									axios="categoriesdynamic"
									:filters="filters"
									:explorePage="true"
									xTitle="Dynamic"
									yTitle="Volume"
									@clicked="keywordClicked"
								></dynvibedynamiccategories>
							</div>
						</div>
					</div>
				</div>
				<dynvibeareastacked ref="areastacked" :title="'chart data'" v-bind="filters" @clicked="keywordClicked"></dynvibeareastacked>
				<top100 ref="top100" level="mastertag" :filters="filters" @clicked="keywordClicked"></top100>
				<moodboard ref="moodboard" :filters="filters"></moodboard>
				<recently v-if="exploreLevel !== 'mastertag'" ref="recently" v-bind="filters" @clicked="keywordClicked"></recently>
				<div v-if="exploreLevel === 'mastertag'" class="row dynvibeRow">
					<div class="col-lg-6">
						<dynvibewordcloud
							ref="keywordWordcloud"
							title="Top keywords"
							axios="wordcloudKeywords"
							:editable="true"
							level="keywords"
							:explorePage="true"
							:clickable="false"
						></dynvibewordcloud>
					</div>
					<div class="col-lg-6">
						<dynvibewordcloud
							ref="hashtagWordcloud"
							title="Top hashtags"
							axios="wordcloudHashtags"
							:editable="true"
							level="hashtags"
							:explorePage="true"
							:clickable="false"
						></dynvibewordcloud>
					</div>
				</div>
				<div v-if="exploreLevel === 'mastertag'" class="row dynvibeRow">
					<div class="col-lg-12">
						<div class="dynvibeBox" style="min-height: 350px">
							<div class="col-lg-12 dynvibeTitleBox">
								<h2>Associated mastertags</h2>
							</div>
							<ul class="tabs-columns">
								<li
									v-bind:class="{
										active: selectedTab === 'mostAssociatedBrands',
									}"
									@click="selectedTab = 'mostAssociatedBrands'"
								>
									<a href="#"> Brands</a>
								</li>
								<li
									v-bind:class="{ active: selectedTab === 'mostAssociatedTrends' }"
									@click="selectedTab = 'mostAssociatedTrends'"
								>
									<a href="#">Trends</a>
								</li>
								<li
									v-bind:class="{ active: selectedTab === 'mostAssociatedTopics' }"
									@click="selectedTab = 'mostAssociatedTopics'"
								>
									<a href="#">Topics</a>
								</li>
							</ul>
							<div style="float: left; padding-left: 20px; padding-top: 8px">
								<label class="labelCheckbox">
									Show trends evolution
									<input type="checkbox" name="displayHighchartsTrend" v-model="displayHighchartsTrend" />
									<span class="checkboxmark"></span>
								</label>
							</div>
							<div class="tabs-content">
								<dynvibecolumn
									:class="'tab-pane ' + (tab == 'Brands' ? 'active' : '')"
									ref="mostAssociated"
									:explorePage="true"
									:axios="selectedTab"
									:clickable="true"
									:legend="true"
									:filters="filters"
									:title="selectedTab"
									levelmixin="mastertag"
									:displayGrowth="displayHighchartsTrend"
									@clicked="keywordClicked"
								></dynvibecolumn>
							</div>
						</div>
					</div>
				</div>

				<div class="row dynvibeRow" style="height: 50px"></div>
			</div>

			<div v-else class="dynvibeBox">
				<div class="row dynvibeRow">
					<div class="col-lg-12 noData">
						<p>No data to display for this period</p>
						<div class="text-center">
							<button
								v-if="filters.mastertag !== ''"
								class="dynvibeButton"
								:disabled="!noDataButton"
								@click="mastertagDetail"
							>
								Go to mastertag details
							</button>
						</div>
					</div>
				</div>
			</div>
			<exploremodal
				:filters="filters"
				:keyword="modalExploreKeyword"
				:level="modalExploreLevel"
				:country="modalExploreCountry"
				:date="modalExploreDate"
				:explorePage="true"
				@closed="modalClosed"
			></exploremodal>
		</div>
	</div>
</template>

<script>
import navpage from "@/components/globalVue/Nav.vue";
import moodboard from "@/components/globalVue/Moodboard.vue";
import explorefilters from "@/components/explore/ExploreFilters.vue";
import exploremodal from "@/components/explore/ExploreModal.vue";
import dynvibeareastacked from "@/components/vueCharts/DynvibeAreaStacked.vue";
import recently from "@/components/globalVue/RecentlyAdded.vue";
import top100 from "@/components/globalVue/Top100.vue";
import dynvibecolumnstacked from "@/components/vueCharts/DynvibeColumnStacked.vue";
import dynvibedynamiccategories from "@/components/vueCharts/DynvibeBubble.vue";
import listcategories from "@/components/globalVue/ListCategories.vue";
import contentgrowth from "@/components/globalVue/ContentGrowth.vue";
import numbers from "@/components/explore/ExploreNumbers.vue";
import dynvibewordcloud from "@/components/vueCharts/DynvibeWordCloud.vue";
import dynvibecolumn from "@/components/vueCharts/DynvibeColumn.vue";
import dynvibestock from "@/components/vueCharts/DynvibeStock.vue";

export default {
	name: "explore",
	components: {
		navpage: navpage,
		moodboard: moodboard,
		explorefilters: explorefilters,
		exploremodal: exploremodal,
		dynvibeareastacked: dynvibeareastacked,
		recently: recently,
		top100: top100,
		dynvibecolumnstacked: dynvibecolumnstacked,
		dynvibedynamiccategories: dynvibedynamiccategories,
		listcategories: listcategories,
		contentgrowth: contentgrowth,
		numbers: numbers,
		dynvibewordcloud: dynvibewordcloud,
		dynvibecolumn: dynvibecolumn,
		dynvibestock: dynvibestock,
	},
	created() {
		this.filters.age = this.$store.getters.parameters.age != undefined ? this.$store.getters.parameters.age : [];
		this.filters.gender = this.$store.getters.parameters.gender != undefined ? this.$store.getters.parameters.gender : [];
		this.filters.sources = this.$store.getters.parameters.sources != undefined ? this.$store.getters.parameters.sources : [];
		this.filters.country = this.$store.getters.parameters.country != undefined ? this.$store.getters.parameters.country : [];
	},
	data() {
		return {
			filters: {
				date: {
					gte: this.$moment().subtract(3, "month").toDate().toISOString().split("T")[0],
					lte: this.$moment().toDate().toISOString().split("T")[0],
				},
				category: "",
				subcategory: "",
				mastertag: "",
				trend: "",
				panel: "",
				typemastertag: "all",
				age: [],
				gender: [],
				sources: [],
				country: [],
			},
			noStacked: true,
			displayGrowth: true, // display percent in volume comparison
			displayHighchartsTrend: true, // display percent in brands/trends/topics tabs
			tab: "Brands",
			selectedTab: "mostAssociatedBrands", // name of selected tab for  brands/trends/topics tabs
			graphrangeVol: "day",
			graphrangeEng: "day",
			selectedCountryVol: "All",
			selectedCountryEng: "All",
			noStockDataVol: false,
			noStockDataEng: false,
			zoomChartVol: 5,
			zoomChartEng: 5,
			stockCountries: [],
			exploreLevel: "category", // (or "" ?)  store the dive explore level -> category, subcategory, mastertag

			modalExploreLevel: "",
			modalExploreKeyword: "", // type could be mastertag, category, subcategory ....
			modalExploreCountry: "",
			modalExploreDate: {
				gte: this.$moment().subtract(3, "month").toDate().toISOString().split("T")[0],
				lte: this.$moment().toDate().toISOString().split("T")[0],
			},
			noData: false,
			noDataButton: false,
			lastSeenMastertag: "",
			showlistcategory: true,
		};
	},
	methods: {
		trendFilters(val) {
			this.filters.date = val.date;
			this.filters.category = val.category;
			this.filters.subcategory = val.subcategory;
			this.filters.mastertag = val.mastertag;
			this.filters.trend = val.trend;
			this.filters.typemastertag = val.typemastertag;
			this.filters.panel = val.panel;
			this.filters.age = this.$store.getters.parameters.age;
			this.filters.gender = this.$store.getters.parameters.gender;
			this.filters.sources = this.$store.getters.parameters.sources;
			this.filters.country = this.$store.getters.parameters.country != undefined ? this.$store.getters.parameters.country : [];
			if (val.listFilters == true) {
				this.showlistcategory = false;
			} else {
				this.showlistcategory = true;
			}
			this.setExploreLevel();
			this.reloadComponents(val.reset);
		},
		changeListCat(resp) {
			this.showlistcategory = resp.showlist;
			this.filters.category = resp.val.category == null ? null : resp.val.category.key;
			this.filters.subcategory = resp.val.subcategory == null ? null : resp.val.subcategory.key;
			this.filters.mastertag = resp.val.mastertag == null ? null : resp.val.mastertag.key;
			this.filters.trend = resp.val.trend == null ? null : resp.val.trend.key;
			this.$refs.explorefilters.reload(resp);
		},
		// define the dive explore level based on filters selected
		setExploreLevel() {
			let level = "category";
			if (this.filters.subcategory !== "" && this.filters.mastertag === "") {
				level = "subcategory";
			}
			if (this.filters.mastertag !== "") {
				level = "mastertag";
			}
			this.exploreLevel = level;
		},
		reloadComponents(reset = false) {
			this.noData = false;
			let parameters = {
				...this.filters,
			};

			// check if component exists (depends on exploreLevel )
			// TODO : maybe try / catch ?
			// if (this.$refs.explorefilters) {
			// 	this.$refs.explorefilters.reload();
			// }
			if (this.$refs.numbers) {
				this.$refs.numbers.checkFilters();
			}
			if (this.$refs.keywordWordcloud) {
				this.$refs.keywordWordcloud.loadComponent(parameters);
			}
			if (this.$refs.hashtagWordcloud) {
				this.$refs.hashtagWordcloud.loadComponent(parameters);
			}

			if (this.$refs.mostAssociated) {
				this.$refs.mostAssociated.loadComponent(parameters);
			}

			if (this.$refs.listCategories) {
				this.$refs.listCategories.reloadAll(parameters, reset);
			}

			if (this.$refs.moodboard) {
				this.$refs.moodboard.reloadModalContent();
			}

			if (this.filters.country.length == 1) {
				this.selectedCountryVol = this.filters.country[0];
				this.selectedCountryEng = this.filters.country[0];
			} else {
				this.selectedCountryVol = "All";
				this.selectedCountryEng = "All";
			}
		},
		// updateParameters() {
		// 	this.filters.date = this.date;

		// },
		setDates() {
			// TODO set date to 3 month by default
			this.$refs.navPage.setDates(this.$moment().subtract(3, "month").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD"));
		},
		changeDate($event) {
			/*			this.date.gte = $event.gte;
			this.date.lte = $event.lte;*/
			this.filters.date.gte = $event.gte;
			this.filters.date.lte = $event.lte;
		},
		editCountries(val) {
			this.stockCountries = val;
		},
		keywordClicked(event) {
			console.log(event);
			if (event.level != "" && typeof event.level !== "undefined") {
				this.modalExploreLevel = event.level;
			} else if (this.filters.mastertag != "" || this.filters.trend != "" || this.filters.subcategory != "") {
				this.modalExploreLevel = "mastertag";
			} else if (this.filters.category != "") {
				this.modalExploreLevel = "subcategories";
			} else {
				this.modalExploreLevel = "categories";
			}

			this.modalExploreKeyword = event.keyword;
			if (event.country && event.country.length > 0) {
				this.modalExploreCountry = event.country;
			}
			this.modalExploreDate = { gte: "", lte: "" };
			if (event.date && event.date.gte) {
				this.modalExploreDate.gte = event.date.gte;
				this.modalExploreDate.lte = event.date.lte;
			} else {
				this.modalExploreDate.gte = this.filters.date.gte;
				this.modalExploreDate.lte = this.filters.date.lte;
			}
		},
		modalClosed() {
			this.modalExploreLevel = "";
			this.modalExploreKeyword = "";
			this.modalExploreCountry = "";
			this.modalExploreDate = {};
		},
		handleNoData() {
			this.noDataButton = false;
			if (this.filters.mastertag !== "") {
				let params = {
					parameters: { ...this.filters },
				};
				this.$axios
					.get(this.$backendUrl + "lastSeenMastertag", {
						params: params,
						paramsSerializer: function (params) {
							return this.$Qs.stringify(params, {
								arrayFormat: "brackets",
							});
						},
					})
					.then((response) => {
						if (response.data.totalResults > 0) {
							this.lastSeenMastertag = response.data.date;
							this.noDataButton = true;
						} else {
							this.lastSeenMastertag = "";
							this.noDataButton = false;
						}
					});
			}

			this.noData = true;
		},
		mastertagDetail() {
			this.modalExploreLevel = "mastertag";
			this.modalExploreKeyword = this.filters.mastertag;
			this.modalExploreCountry = "";
			this.modalExploreDate.lte = this.$moment(this.lastSeenMastertag).format("YYYY-MM-DD");
			this.modalExploreDate.gte = this.$moment(this.lastSeenMastertag).subtract(6, "month").format("YYYY-MM-DD");
		},
		removeBrands() {
			if (this.$refs.explorefilters.typemastertag === "brand") {
				this.$refs.explorefilters.typemastertag = "all";
			}
		},
		changeZoomChart(zoomChart, type) {
			if (type == "volume") {
				this.zoomChartVol = zoomChart;
			} else if (type == "engagement") {
				this.zoomChartEng = zoomChart;
			}
		},
	},
	watch: {
		"$store.getters.parameters": function () {
			this.$refs.explorefilters.checkFilter();
		},
		"$store.getters.panel"(newVal) {
			this.filters.panel = newVal;
			if (newVal) {
				// prevent error when reloading page
				this.reloadComponents();
			}
		},
		graphrangeVol(newVal) {
			let chartOptions = this.$refs.stockVol.$refs.basechart.getChartOptions();
			for (let i = 0; i < chartOptions.series.length; i++) {
				chartOptions.series[i].dataGrouping.units = [[newVal, [1]]];
			}
			this.$refs.stockVol.changeZoom(this.zoomChartVol);
		},
		graphrangeEng(newVal) {
			let chartOptions = this.$refs.stockEng.$refs.basechart.getChartOptions();
			for (let i = 0; i < chartOptions.series.length; i++) {
				chartOptions.series[i].dataGrouping.units = [[newVal, [1]]];
			}
			this.$refs.stockEng.changeZoom(this.zoomChartEng);
		},
	},
};
</script>
<style scoped>
.labelCheckbox {
	display: inline;
	position: relative;
	padding-left: 25px;
	margin-right: 10px;
	margin-bottom: 12px;
	cursor: pointer;
	font-size: 14px;
	font-weight: 700;
	color: #8e8e8e;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

/* Hide the browser's default checkbox */
.labelCheckbox input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
	height: 0;
	width: 0;
}

/* Create a custom checkbox */
.checkboxmark {
	position: absolute;
	top: 0;
	left: 0;
	height: 15px;
	width: 15px;
	background-color: #eee;
}

.labelCheckbox:hover input ~ .checkboxmark {
	background-color: #eee;
}

.checkboxmark:after {
	content: "\e923";
	position: absolute;
	display: none;
}

.labelCheckbox input:checked ~ .checkboxmark:after {
	display: block;
}

.checkboxmark:after {
	content: "\e923";
	position: absolute;
	top: -2px;
	font-family: i;
	font-size: 11px;
	line-height: 20px;
}

.tabs-columns {
	border-bottom: none;
	list-style: none;
	padding-left: 0;
	margin-bottom: 60px;
}

.tabs-columns > li {
	position: relative;
	display: block;
	float: left;
	padding-top: 10px;
	padding-right: 15px;
	padding-bottom: 10px;
	padding-left: 15px;
	background-color: transparent;
	font-size: 16px;
	font-weight: 700;
	color: #cacaca;
	text-transform: uppercase;
}

.tabs-columns > li.active > a {
	color: #757575;
}

.tabs-columns > li:first-child a:before {
	content: "";
	display: block;
	position: absolute;
	left: 15px;
	bottom: 0;
	width: 20px;
	height: 4px;
	background-color: #757575;
	z-index: 0;
}

.tabs-content {
	margin-left: -25px;
	margin-right: -25px;
}

/* INPUT RADIO */
.labelRadio {
	display: inline;
	position: relative;
	padding-left: 20px;
	margin-right: 10px;
	margin-bottom: 12px;
	cursor: pointer;
	font-size: 14px;
	font-weight: 700;
	color: #8e8e8e;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

/* Hide the browser's default checkbox */
.labelRadio input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
	height: 0;
	width: 0;
}

/* Create a custom checkbox */
.checkmark {
	position: absolute;
	top: 2px;
	left: 0;
	height: 15px;
	width: 15px;
	background-color: #fff;
	border-radius: 50%;
	border: 1px solid #33d1cd;
}

/* On mouse-over, add a grey background color */
.labelRadio:hover input ~ .checkmark {
	background-color: rgba(51, 209, 205, 0.2);
}

/* When the checkbox is checked, add a blue background */
.labelRadio input:checked ~ .checkmark {
	background-color: #33d1cd;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
	content: "";
	position: absolute;
	display: none;
}

/* Show the checkmark when checked */
.labelRadio input:checked ~ .checkmark:after {
	display: block;
}

.labelCheckbox {
	display: inline;
	position: relative;
	padding-left: 25px;
	margin-right: 10px;
	margin-bottom: 12px;
	cursor: pointer;
	font-size: 14px;
	font-weight: 700;
	color: #8e8e8e;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

/* Hide the browser's default checkbox */
.labelCheckbox input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
	height: 0;
	width: 0;
}

/* Create a custom checkbox */
.checkboxmark {
	position: absolute;
	top: 0;
	left: 0;
	height: 15px;
	width: 15px;
	background-color: #eee;
}

.labelCheckbox:hover input ~ .checkboxmark {
	background-color: #eee;
}

.checkboxmark:after {
	content: "\e923";
	position: absolute;
	display: none;
}

.labelCheckbox input:checked ~ .checkboxmark:after {
	display: block;
}

.checkboxmark:after {
	content: "\e923";
	position: absolute;
	top: -2px;
	font-family: i;
	font-size: 11px;
	line-height: 20px;
}
</style>
